export default __webpack_public_path__ + "static/media/blog.34887b4f.svg";